/*
  Belmint hover zoom for product photos.
  Mouse only: the photo zooms in and follows the cursor while you hover.
  Click still opens Dawn's full screen view. Touch screens are left alone.
*/
(() => {
  if (window.BelmintZoom) return;
  window.BelmintZoom = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const ZOOM = 2.2;
  const GALLERY = '.product__media-list .product-media-container.media-type-image';
  let active = null;

  const reset = () => {
    if (!active) return;
    const img = active.querySelector('.product__media img');
    if (img) {
      img.style.transform = '';
      img.style.transformOrigin = '';
    }
    active = null;
  };

  document.addEventListener('mousemove', (e) => {
    const box = e.target.closest ? e.target.closest(GALLERY) : null;
    if (box !== active) reset();
    if (!box) return;
    const frame = box.querySelector('.product__media');
    const img = frame && frame.querySelector('img');
    if (!img) return;
    // Measure the frame, not the image, because the image is already scaled.
    const r = frame.getBoundingClientRect();
    if (!r.width || !r.height) return;
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    active = box;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = `scale(${ZOOM})`;
  });

  document.addEventListener('mouseleave', reset);
  window.addEventListener('scroll', reset, { passive: true });
})();
